import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import toJSComponent from "with-immutable-props-to-js";

import theme from "layout/themes";
import { getMarkerFromState } from "features/planner/planner.selectors";

const Marker = ({ marker, size }) => {
  if (!marker) return null;

  const { name, icon } = marker;

  return <img alt={""} src={icon} height={size} width={size} title={name} />;
};

Marker.defaultProps = {
  size: theme.spacing(2),
};

export default compose(
  connect((state, { markerId, marker }) => ({
    marker: marker
      ? marker
      : markerId
      ? getMarkerFromState(state, markerId)
      : undefined,
  })),
  toJSComponent,
)(Marker);
